import { render, staticRenderFns } from "./CardSurah.vue?vue&type=template&id=7449b698&"
import script from "./CardSurah.vue?vue&type=script&lang=js&"
export * from "./CardSurah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports